"use client";
import { ChatProvider } from '@/contexts/ChatContext';
import { ChatApiUrls } from '@/types/chat';

// Define agent API URLs (mirror chat but with agent-prefixed endpoints)
const apiUrls: ChatApiUrls = {
  chatApiUrl: '/api/agent/chat-messages',
  conversationsApiUrl: '/api/agent/conversations',
  messagesFeedbackApiUrl: '/api/agent/messages',
  uploadApiUrl: '/api/agent/files/upload',
  // Captioner uses unified key and same endpoint
  captionApiUrl: '/api/files/get-caption',
};

export default function PublicChatEnabledLayout({ children }: { children: React.ReactNode }) {
  return (
    <ChatProvider apiUrls={apiUrls}>
      {children}
    </ChatProvider>
  );
}